module.exports = __webpack_public_path__ + "img/default-picture.7bf4da60.svg";